import axios from 'axios'
import constant from './Constant'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import router from '../../src/router'

let vm = new Vue({
  router
})

export default {
  post,
  postWithMsg,
}

function post(interfaceName, form, callback, errorCallBack, needRequestKey = true) {
  var uid = localStorage.getItem("uid")
  console.log('uid is ')
  console.log(uid)
  if (uid === undefined || uid === null) {
    uid = uuid()
    localStorage.setItem("uid", uid)
  }
  form['iv'] = constant.iv
  form['dt'] = 32021
  form['dd'] = navigator.userAgent
  form['du'] = uid

  if (needRequestKey) {
    form['requestKey'] = constant.requestKey
  }

  form['st'] = Date.parse(new Date())
  axios({
    url: constant.url + interfaceName,
    method: 'post',
    data: JSON.stringify(form),
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
  }).then(object => {
    callback(object.data)
  }).catch(error => {
    errorCallBack(error)
  })
}

function postWithMsg(interfaceName, form, onSuccess, showSuccess, onFail, needRequestKey = true) {
  if (showSuccess === undefined) {
    showSuccess = false
  }
  let loadingInstantce = elementUI.Loading.service({fullscreen: true})
  post(interfaceName, form, obj => {
    loadingInstantce.close()
    let code = obj.code
    if (code === '1000') {
      if (showSuccess) {
        elementUI.Message({
          message: obj.info,
          type: 'success'
        })
      }

      if (onSuccess !== undefined) {
        onSuccess(obj)
      }
    } else {
      elementUI.Message.error(obj.info)
      if (code === '2001') {
        vm.$router.push({path: '/'})
      } else {
        if (onFail !== undefined) {
          onFail(obj)
        }
      }
    }
  }, error => {
    console.log(error)
    loadingInstantce.close()
    elementUI.Message.error('服务请求失败：' + error)
  }, needRequestKey)
}

function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}



//////////////////
// WEBPACK FOOTER
// ./static/js/BaseJs.js
// module id = null
// module chunks = 